<p-accordionTab header="MVD Now Registration Requests" *ngIf="showRegistrationRequestQueue">
    <p-table styleClass="p-datatable-striped" [value]="customerRequestQueueData.queueItems" #dataTable [sortOrder]="1">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="7">
                    No Records Found
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'assignedUserLoginName'">Assigned To<p-sortIcon [field]="'assignedUserLoginName'"></p-sortIcon></th>
                <th [pSortableColumn]="'customerName'">Customer Name<p-sortIcon [field]="'customerName'"></p-sortIcon></th>
                <th [pSortableColumn]="'displayDateOfBirth'" class="w--date-time">Customer DOB<p-sortIcon [field]="'displayDateOfBirth'"></p-sortIcon></th>
                <th [pSortableColumn]="'customerRequestStatusName'">Status<p-sortIcon [field]="'customerRequestStatusName'"></p-sortIcon></th>
                <th [pSortableColumn]="'createdDate'" class="w--date-time">Submitted Date/Time<p-sortIcon [field]="'createdDate'"></p-sortIcon></th>
                <th [pSortableColumn]="'elapsedTime'" class="w--date-time">Elapsed Time<p-sortIcon [field]="'elapsedTime'"></p-sortIcon></th>
                <th class="w--icon">View</th>
            </tr>
         </ng-template>
        <ng-template pTemplate="body" let-queueItem>
            <tr [pSelectableRow]="queueItem">
                <td>
                    <select class="mvd_form-control" (change)="changeAssignedUser(queueItem.customerRequestId, $event.target.value)">
                        <option [selected]="queueItem.assignedUserLoginId == null" value="">Unassigned</option>
                        <option *ngFor="let user of customerRequestQueueData.users"
                                value="{{user.id}}"
                                [selected]="queueItem.assignedUserLoginId == user.id">
                            {{user.firstName}} {{user.lastName}}
                        </option>
                    </select>
                </td>
                <td>
                    <a href="javascript:void(0)" (click)="openSearchCustomerModal(queueItem)">{{queueItem.customerName}}</a>
                </td>
                <td>{{ queueItem.displayDateOfBirth }}</td>
                <td>
                    <select class="mvd_form-control" (change)="changeStatusType(queueItem.customerRequestId, $event.target.value)">
                        <option *ngFor="let customerRequestStatus of customerRequestQueueData.customerRequestStatusTypes"
                                value="{{customerRequestStatus._Id}}"
                                [selected]="queueItem.customerRequestStatusTypeId == customerRequestStatus._Id">
                            {{customerRequestStatus._DisplayValue}}
                        </option>
                    </select>
                </td>
                <td> {{queueItem.displayCreatedDate}} </td>
                <td> {{queueItem.displayElapsedTime }} </td>
                <td class="text-center">
                    <a class="icon--view" href="javascript:void(0)" title="View Request" (click)="openRequestModal(queueItem.customerRequestId)"></a>
                </td>
            </tr>
        </ng-template>
</p-table>
</p-accordionTab>